import React from "react";

import { ButtonGroup, Button } from "../../ppui/button";

const StatusFilter = ({ uniqueStatuses, onStatusFilter }) => {
  return (
    <ButtonGroup variant="outlined">
      <Button onClick={() => onStatusFilter("All")}>All</Button>
      {uniqueStatuses.map((status) => (
        <Button key={status} onClick={() => onStatusFilter(status)}>
          {status}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default StatusFilter;
